import Promise from 'bluebird';

Promise.config({
    warnings: process.env.NODE_ENV !== 'production'
});

if (!window.Promise) {
    window.Promise = Promise;
}



// WEBPACK FOOTER //
// ./app/polyfills.js